import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export default function MetricCard({ title, value, hint, icon: Icon, trend, className }) {
  return (
    <Card className={cn('transition-shadow hover:shadow-md', className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
        {Icon && <Icon className="h-4 w-4 text-primary" aria-hidden />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold tracking-tight sm:text-3xl">{value}</div>
        {(hint || trend) && (
          <p className="mt-1 text-xs text-muted-foreground">
            {trend && <span className="font-medium text-primary">{trend} </span>}
            {hint}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
